import * as React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

import { CLAIM_US_TYPES } from '~features/claimer';

import { Distribution, PoolToken } from '../../types';

export function DistributionType({
  distribution,
  token,
}: {
  distribution: Distribution;
  token: PoolToken;
}) {
  if (distribution.type === 'airdrop_them') {
    return <span>Airdropped by {token.name} team</span>;
  } else if (distribution.type === 'claim_them') {
    return (
      <span>
        Claimable on{' '}
        {distribution.claimUrl ? (
          <a href={distribution.claimUrl}>
            {token.name}'s platform{' '}
            <FaExternalLinkAlt className="inline ml-1" />
          </a>
        ) : (
          <>{token.name}'s platform </>
        )}
      </span>
    );
  } else if (distribution.type === 'airdrop_us') {
    return <span>Airdropped by TrustPad team</span>;
  } else if (CLAIM_US_TYPES.includes(distribution.type)) {
    return <span>Claimed on TrustPad</span>;
  } else if (distribution.type === 'mint_them') {
    return (
      <span>
        Mint
        {distribution.claimUrl ? (
          <>
            {' '}
            on the <a href={distribution.claimUrl}>project's platform</a>
          </>
        ) : (
          ''
        )}
      </span>
    );
  }

  return null;
}
